module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="apexChat_poke_wrapper">\r\n    <div id="apexchat_poke_msg_container" class="apexChat_poke_msg_wrapper">\r\n        <!-- Message Template here -->\r\n    </div>\r\n    <div id="apexChat_poke_btn" class="apexChat_poke_btn">' +
((__t = (userResponseText)) == null ? '' : __t) +
'</div>\r\n</div>\r\n';

}
return __p
}